import intl from "src/internationalization/intl"
import { Grid, TabFilters, TextInput } from "src/lib"
import type { Filter } from "src/lib/components/basics/TabFilters/types"

const PERIOD_FILTERS: Filter[] = [
    { id: "mtd", value: "mtd", label: intl("periodMTD") },
    { id: "ytd", value: "ytd", label: intl("periodYTD") },
    { id: "custom", value: "custom", label: intl("periodCustom") },
]

interface PeriodRangeSelectorProps {
    selectedPeriod: Filter
    onPeriodChange: (filter: Filter) => void
    customStart: string
    customEnd: string
    onCustomStartChange: (value: string) => void
    onCustomEndChange: (value: string) => void
}

/** Filtro de janela de análise (MTD / YTD / Personalizado) usado nas seções macro do painel do gestor. */
const PeriodRangeSelector = ({
    selectedPeriod,
    onPeriodChange,
    customStart,
    customEnd,
    onCustomStartChange,
    onCustomEndChange,
}: PeriodRangeSelectorProps) => {
    return (
        <Grid container gap={1.5} alignItems="center" justifyContent="flex-end" sx={{ flexWrap: "wrap", rowGap: 1 }}>
            {selectedPeriod.id === "custom" && (
                <Grid container gap={1} alignItems="center" wrap="nowrap">
                    <TextInput
                        label={intl("periodCustomStart")}
                        type="date"
                        size="small"
                        value={customStart}
                        onChange={(e: any) => onCustomStartChange(e.target.value)}
                        sx={{ width: 135 }}
                    />
                    <TextInput
                        label={intl("periodCustomEnd")}
                        type="date"
                        size="small"
                        value={customEnd}
                        onChange={(e: any) => onCustomEndChange(e.target.value)}
                        sx={{ width: 135 }}
                    />
                </Grid>
            )}
            <Grid item sx={{ flex: 1, minWidth: 0 }}>
                <TabFilters filters={PERIOD_FILTERS} selectedFilter={selectedPeriod} onFilterChange={onPeriodChange} />
            </Grid>
        </Grid>
    )
}

export { PeriodRangeSelector, PERIOD_FILTERS }
